import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {Button} from "semantic-ui-react";
import AceEditor from 'react-ace';
import {IfBox} from "../../../style/if";
import {ExportSimCisDocTable} from "../converter/ExportSim/output/ExportSimCisDocTable";
import {ConfigContext} from "../../context/ConfigContext";
import {EncodingSelector} from "./EncodingSelector";

export interface CisDocViewerProps {
    output: string
}

export function CisDocViewer(props: React.PropsWithChildren<CisDocViewerProps>) {
    const context = useContext(ConfigContext);
    const [cisDoc, setCisDoc] = useState("");
    const [drawTable, setDrawTable] = useState(false);
    const [encoding, setEncoding] = useState('UTF-8');

    useEffect(() => {
        if (props.output) {
            context.setCisDoc(props.output);
        }
        setCisDoc(context.cisDoc);
    }, [props.output, context]);

    const handleDrawTable = () => {
        setDrawTable(true);
    };

    return (
        <>
            <AceEditor
                theme="monokai"
                mode='groovy'
                style={{flex: 2}}
                value={cisDoc}
                placeholder='copy your CIS-Document here!'
                width="100%"
                onChange={(value) => {
                    setCisDoc(value);
                    setDrawTable(false);
                    context.setCisDoc(value);
                }}
                readOnly={false}
            />
            <div>
                <EncodingSelector
                    encoding={encoding}
                    onChange={(encoding) => {
                        setDrawTable(false);
                        setEncoding(encoding)
                    }}
                />
                <Button type="button" onClick={handleDrawTable}>Draw Table</Button>
            </div>
            <div style={{flex: 2}}>
                <IfBox shouldShow={drawTable}>
                    <ExportSimCisDocTable output={cisDoc} encoding={encoding}/>
                </IfBox>
            </div>
        </>
    );
}
